// initial state
// shape: [{ id, quantity }]
const state = {
  // 表格数据
  table: [],
  // 分页参数
  pagination: {
    current_page: 1,
    per_page: 20,
    total: 0,
  },
}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getEducationTable ({commit, state}, params) {
    let promised = request.alert('getEducationTable', params)
    return promised
  },
  createEducation ({commit, state}, params) {
    let promised = request.alert('createEducation', params)
    return promised
  },
  editEducation ({commit, state}, params) {
    let promised = request.alert('editEducation', params)
    return promised
  },
  editEducationLevel ({commit, state}, params) {
    let promised = request.alert('editEducationLevel', params)
    return promised
  },
  uploadFile ({commit, state}, params) {
    let promised = request.alert('uploadFile', params)
    return promised
  },
  deleteEducation ({commit, state}, id) {
    let promised = request.alert('deleteEducation', id)
    return promised
  },
  getHotTag ({commit, state}, id) {
    let promised = request.alert('getHotTag', id)
    return promised
  },
  getEducation ({commit, state}, id) {
    let promised = request.alert('getEducation', id)
    return promised
  },
  deleteHotTag ({commit, state}, id) {
    let promised = request.alert('deleteHotTag', id)
    return promised
  },
  addHotTag ({commit, state}, params) {
    let promised = request.alert('addHotTag', params)
    return promised
  },
  getHomeModuleTable ({commit, state}, params) {
    let promised = request.alert('getHomeModuleTable', params)
    return promised
  },
  createModule ({commit, state}, params) {
    let promised = request.alert('createModule', params)
    return promised
  },
  editModule ({commit, state}, params) {
    let promised = request.alert('editModule', params)
    return promised
  },
  getAvailableModule ({commit, state}, params) {
    let promised = request.alert('getAvailableModule', params)
    return promised
  },
  getModuleOperateLog ({commit, state}, params) {
    let promised = request.alert('getModuleOperateLog', params)
    return promised
  },
}

// mutations
const mutations = {}

export const platform = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/platform/platform.store.js